// extracted by mini-css-extract-plugin
export var modal = "_gh-0";